import React from 'react';
import { FaTimes, FaPlus } from 'react-icons/fa';

const ParkingModal = ({ isOpen, onClose, parkingData, selectedParkingId, onEdit, onRepark }) => {
  if (!isOpen || !selectedParkingId) return null;

  const selectedParking = parkingData.find(item => item.id === selectedParkingId);
  
  if (!selectedParking) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[95vh] sm:max-h-[90vh] overflow-y-auto relative">
        {/* Header */}
        <div className="flex justify-between items-center p-1 sm:p-3 text-right">
          {/*<h2 className="text-lg sm:text-xl font-bold text-gray-800 m-0">Parking Details</h2>*/}
          <button 
            onClick={onClose}
            className="p-1 sm:p-2 w-full text-gray-600 clear-both hover:text-accent transition-colors text-right rounded-full hover:bg-gray-100"
          >
            <FaTimes className="text-lg sm:text-xl float-right" />
          </button>
        </div>

        {/* Content */}
        <div className="p-1 pb-5 sm:p-6">
          {selectedParking.status == 4 && (
            <div className='text-center w-100 flex justify-center items-center mb-4 sm:mb-6'>
              <button 
                onClick={() => onRepark(selectedParking.id)}
                className="py-2 px-4 sm:py-3 sm:px-6 bg-cyan-500 rounded-xl text-white text-sm sm:text-base md:text-lg font-bold uppercase hover:bg-accent transition-colors flex items-center gap-2"
              >
                <span>Repark Car</span> <FaPlus className="text-sm sm:text-lg" />
              </button>
            </div>
          )}

          <div className='mb-4 sm:mb-6'>
            <div className='text-sm sm:text-lg font-bold text-center space-y-1 sm:space-y-2'>
              <div>Space Number: <span className="text-accent">{selectedParking.stall_number || "Not set"}</span></div>
              <div>Driver: <span className="text-accent">{selectedParking.driver || "Not set"}</span></div>
              {selectedParking.closing_driver && (
                <div>Closing Driver: <span className="text-accent">{selectedParking.closing_driver}</span></div>
              )}
            </div>
          </div>

          {/* Customer Information Grid */}
          <div className='mb-1 sm:mb-2'>
            <div className="grid grid-cols-3 gap-0 border border-gray-300 rounded-lg overflow-hidden">
              {/* Headers */}
              <div className="font-bold text-sm sm:text-base md:text-lg p-1 border-b border-gray-300 bg-gray-50">Name</div>
              <div className="font-bold text-sm sm:text-base md:text-lg p-1 border-b border-l border-gray-300 bg-gray-50">Phone</div>
              <div className="font-bold text-sm sm:text-base md:text-lg p-1 border-b border-l border-gray-300 bg-gray-50">Email</div>
              
              {/* Data */}
              <div className="text-sm sm:text-base md:text-lg p-1">{selectedParking.customer_name || 'N/A'}</div>
              <div className="text-sm sm:text-base md:text-lg p-1 border-l border-gray-300">{selectedParking.customer_phone || 'N/A'}</div>
              <div className="text-sm sm:text-base md:text-lg p-1 border-l border-gray-300 break-all">{selectedParking.customer_email || 'N/A'}</div>
            </div>
          </div>

          {/* Vehicle Information Grid */}
          <div className='mb-4 sm:mb-6'>
            <div className="grid grid-cols-3 gap-0 border border-gray-300 rounded-lg overflow-hidden">
              {/* Headers */}
              <div className="font-bold text-sm sm:text-base md:text-lg p-1 border-b border-gray-300 bg-gray-50">Color</div>
              <div className="font-bold text-sm sm:text-base md:text-lg p-1 border-b border-l border-gray-300 bg-gray-50">Plate</div>
              <div className="font-bold text-sm sm:text-base md:text-lg p-1 border-b border-l border-gray-300 bg-gray-50">Make</div>
              
              {/* Data */}
              <div className="text-sm sm:text-base md:text-lg p-1">{selectedParking.vehicle_color || 'N/A'}</div>
              <div className="text-sm sm:text-base md:text-lg p-1 border-l border-gray-300">{selectedParking.vehicle_plate || 'N/A'}</div>
              <div className="text-sm sm:text-base md:text-lg p-1 border-l border-gray-300">{selectedParking.vehicle_make || 'N/A'}</div>
            </div>
          </div>

          <div className='grid grid-cols-1 sm:grid-cols-2 gap-1 mb-4 sm:mb-6'>
              {/*<h3 className="text-sm sm:text-base font-semibold text-gray-700 border-b pb-1">Timing</h3>*/}
              <div className="text-sm sm:text-base md:text-lg font-bold">Checkin: <span className="font-medium">{selectedParking.time_created}</span></div>
              <div className="text-sm sm:text-base md:text-lg font-bold">Parking Time: <span className="font-medium">{selectedParking.parking_time || 'N/A'}</span></div>
              {(selectedParking.charge_amount > 0) && (
                <div className="text-sm sm:text-base md:text-lg font-bold">Charge Amount: <span className="font-medium">${selectedParking.charge_amount || 'N/A'}</span></div>
              )}
              <div className="text-sm sm:text-base md:text-lg font-bold">Checkout: <span className="font-medium">{selectedParking.time_closed}</span></div>
            
          </div>

          <div className='flex justify-center'>
            <button
              onClick={() => onEdit(selectedParking.id)}
              className='py-2 px-4 sm:py-3 sm:px-6 bg-darkgrey text-white rounded-xl hover:bg-accent transition-colors font-medium text-sm sm:text-base'
            >
              Edit Transaction
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParkingModal;
